import { type IGetECLAccountParams } from "./types"

export const shoppersKeys = {
  all: ["shoppers"] as const,
  details: () => [...shoppersKeys.all, "detail"] as const,
  detail: (shopper_guid: string | undefined | null) =>
    [...shoppersKeys.details(), shopper_guid] as const,
  eclAccount: (
    market_code: string | undefined,
    params: IGetECLAccountParams | undefined,
  ) =>
    [
      ...shoppersKeys.all,
      "retentionOffersForAccount",
      market_code,
      params,
    ] as const,
}
